import { apiFetchEnvelope, type ListMeta } from "@core/http";
import type { operations } from "@core/types/openapi";

type AccessLogQuery = NonNullable<
  operations["portalQueryAccessLog"]["parameters"]["query"]
>;
type AccessLogResponse = NonNullable<
  operations["portalQueryAccessLog"]["responses"][200]["content"]["application/json"]
>;

export type AccessLogFilters = Pick<
  AccessLogQuery,
  "result" | "origin" | "staffUserId" | "from" | "to"
>;

export type AccessLogPage = {
  items: NonNullable<AccessLogResponse["data"]>["items"];
  availableFrom: NonNullable<AccessLogResponse["data"]>["availableFrom"];
  meta: ListMeta;
};

export async function queryAccessLog(
  filters: AccessLogFilters,
  cursor?: string,
): Promise<AccessLogPage> {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries({ ...filters, cursor })) {
    if (value) params.set(key, value);
  }
  const suffix = params.size ? `?${params}` : "";
  const envelope = await apiFetchEnvelope<
    NonNullable<AccessLogResponse["data"]>
  >(`/v1/portal/security/access-log${suffix}`);
  return {
    items: envelope.data.items,
    availableFrom: envelope.data.availableFrom,
    meta: envelope.meta ?? { next: null, total: envelope.data.items.length },
  };
}
